export default class HostedPage {
  /**
   * Create new HostedPage and set properties based on the given object.
   *
   * @param {Object} obj
   */
  constructor (obj) {
    Object.assign(this, obj)
  }

  /**
   * @return {Date}
   */
  get updatedAt () {
    return this._updatedAt
  }

  /**
   * @param {string} value
   */
  set updatedAt (value) {
    this._updatedAt = new Date(value)
  }
}
